<template>
  <div class="not-register">
    <section class="wrapper">
      <h1 class="title-1">欢迎你加入TME数字音乐管理平台</h1>
      <div class="title-2" />
      <h2 class="title-3">入驻身份选择</h2>

      <ul class="entry">
        <li class="entry-item entry-bg-1" @click="handleCompanyApply(true)" />
        <li class="entry-item entry-bg-2" @click="handleCompanyApply(false)" />
        <li class="entry-item entry-bg-3" @click="handleAppealApply()" />
      </ul>

      <p class="inner-entry" @click="handleEditorApply" />
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ROLE_TYPE_ENUM, SIGN_STATUS } from '@/views/person/const'

export default {
  name: 'Person',
  data() {
    return {
      SIGN_STATUS
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'company'])
  },
  methods: {
    handleCompanyApply(signed) {
      this.$router.push({ name: 'registerEdit', query: { roleType: ROLE_TYPE_ENUM.COMPANY.code, signed } })
    },
    handleEditorApply() {
      this.$router.push({ name: 'registerEdit', query: { roleType: ROLE_TYPE_ENUM.EDITOR.code } })
    },
    handleAppealApply() {
      this.$router.push({ name: 'registerEdit', query: { roleType: ROLE_TYPE_ENUM.ORGANIZATION.code } })
    },
  }
}
</script>

<style scoped lang="scss">
.not-register {
  padding-top: 150px;
  height: calc(100vh - 60px);
  min-height: 1000px;
  text-align: center;
  color: #fff;
  background-color: #000000;

  .wrapper {
    width: 1200px;
    margin: 0 auto;
  }

  .title-1 {
    color: #FFF;
    font-size: 48px;
  }

  .title-2 {
    width: 712px;
    height: 43px;
    margin: 18px auto;
    flex-shrink: 0;
    border-radius: 30px;
    background: url('~@/assets/images/not_register_tit.png'), lightgray 50% / cover no-repeat;
    mix-blend-mode: luminosity;
  }

  .title-3 {
    margin-top: 60px;
    color: #FFF;
    font-size: 36px;
  }

  .entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    .entry-item {
      width: 269px;
      height: 388px;
      padding: 30px 0;
      border-radius: 50px;
      cursor: pointer;
      background-size: cover;

      &.entry-bg-1 {
        background-image: url('~@/assets/images/not_register_bg1.png');
      }

      &.entry-bg-2 {
        background-image: url('~@/assets/images/not_register_bg2.png');
      }

      &.entry-bg-3 {
        background-image: url('~@/assets/images/not_register_bg3.png');
      }

      img {
        width: 152px;
        height: 152px;
        margin-top: 10px;
      }

      p {
        color: #FFF;
        text-align: center;
        font-size: 32px;
        font-weight: 700;
      }
    }
  }

  .inner-entry {
    float: right;
    margin-top: 20px;
    width: 322px;
    height: 54px;
    line-height: 54px;
    border-radius: 130px;
    background: url('~@/assets/images/not_register_bg4.png');
    box-shadow: 3px 2px 10px 0px rgba(77, 117, 186, 0.80) inset;
    cursor: pointer;

    font-size: 20px;
    color: #000;
    font-weight: bold;
  }
}
</style>
